import { render, staticRenderFns } from "./SimpleRenderer.vue?vue&type=template&id=9aa23864&scoped=true"
import script from "./SimpleRenderer.vue?vue&type=script&lang=js"
export * from "./SimpleRenderer.vue?vue&type=script&lang=js"
import style0 from "./SimpleRenderer.vue?vue&type=style&index=0&id=9aa23864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa23864",
  null
  
)

export default component.exports